import LogBaseController from '../common/log.base.controller'
import _ from 'lodash';

class LogAllController extends LogBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, LogService, $translate, $stateParams, $location, $q, SetupService, DateUtil, UserBranchService, DataCounter) {
    super(Auth, $state, User, LogService, Modal, $translate, $stateParams, $location, $q, SetupService, DateUtil, UserBranchService)

    this.loading = false
    this.logs = []
    this.hasAcl = {}
    this.page = 1;
    this.total = 0;
    this.pageLimit = 25;
    this.maxPages = 10
    this.searchText = '';
    this.logsOf = '';
    // this.entryType = ''
    this.$location = $location;
    this.DateUtil = DateUtil;
    this.$q = $q;
    this.SetupService = SetupService;
    this.UserBranchService = UserBranchService;
    this.DataCounter = DataCounter;
    this.entryTypes = [];
    this.model = {
      branchId: null,
      dateRange: {
        startDate: '',
        endDate: ''
      },
      loggedInUser: User.getUser().id
    }
  }

  setDateRange(date) {
    let currentVaultDate = date || moment();
    this.model.dateRangPickerOptions = {
      autoApply: true,
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.page = 1;
          this.loadData(this.model.dateRange);
        }
      },
      ranges: {
        'Today': [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        'Current Week': [
          moment().startOf('week').format('YYYY-MM-DD'),
          moment().endOf('week').format('YYYY-MM-DD')
        ],
        'Current Month': [
          moment().startOf('month').format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD')
        ]
      }
    }
  }

  $onInit() {
    this.billableEventObj = this.DataCounter.getData();
    if (this.billableEventObj && this.billableEventObj.isRedirected) {
      this.searchText = this.billableEventObj.searchText;
      this.entryType = this.billableEventObj.billableEvent;
      this.branchId = this.billableEventObj.branchId;
    }

    this.model.loading = true;
    let pageId = this.$stateParams.page,
        branch = this.User.getUser().branchId;

    if (pageId > 0) {
      this.page = pageId
    }

    this.$q.all([
      this.SetupService.get(branch),
      this.UserBranchService.getUserBranches(this.model.loggedInUser)
    ])
      .then((data) => {
        this.currentVaultDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
        this.vaultDate = moment().format('YYYY-MM-DD');
        this.setDateRange(this.vaultDate);

        if (this.billableEventObj && this.billableEventObj.isRedirected) {
          this.model.dateRange.startDate = moment(this.billableEventObj.createdAt).format('YYYY-MM-DD 00:00:00');
          this.model.dateRange.endDate = moment(this.billableEventObj.createdAt).add(1, 'days').format('YYYY-MM-DD 23:59:59');
        }
        else {
          this.model.dateRange.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
          this.model.dateRange.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');
        }

        this.branches = data[1].results;
        this.model.branchId = branch;
      })
      .then(() => {
        this.loadData()
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

  refresh() {
    this.loadData();
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    return {
      logsOf: this.logsOf,
      entryType: this.entryType,
      queryText: this.searchText,
      isQuery: false,
      startDate: moment(this.model.dateRange.startDate).startOf('day').format('YYYY-MM-DD 00:00:00'),
      endDate: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      branchId: this.model.branchId || ''
    }
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();

    this.loading = true
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.logs = data.results

        this.logs.forEach((log) => {

          log.readableEntryType = this.$translate.instant('entry_type.' + log.entryType)
          if (log.entryData) {
            log.extraDetails = Object.entries(log.entryData).map((entry) => {
              return {
                key: entry[0],
                value: typeof entry[1] === 'object' ? JSON.stringify(entry[1]) : entry[1]
              };
            });
          }
        });
        if (data.allEntryTypes.length > 0) {
          this.entryTypes = data.allEntryTypes.map((entryType) => {
            return {
              label: this.$translate.instant('entry_type.' + entryType),
              value: entryType
            };
          });
        }
      })
      .then(() => {
        this.resetRedirectionData();
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  toggleExpand(log) {
    log.expand = !log.expand;
  }

  setLogsOf(value) {
    this.logsOf = this.logsOf === value ? undefined : value;
    this.loadData();
  }

  filterData() {
    this.page = 1;
    this.loadData();
  }

  showShipmentReceipt(log, stats) {
    let shipmentObj = {};

    log.forEach((details) => {
      Object.assign(shipmentObj, new Object({ [details.key]: details.value }))
    })

    document.getElementById('shipment-image').blur();
    this.Modal.shipmentImageModal(shipmentObj, shipmentObj.trackingId, stats, ({ modal }) => {
    }, ({ modal }) => {
      modal.close();
    });
  }

  resetRedirectionData() {
    if (this.billableEventObj) {
      this.billableEventObj.isRedirected = false;
      this.billableEventObj = this.DataCounter.setData();
    }
  }
}

export default LogAllController;


// WEBPACK FOOTER //
// ./client/app/components/log/all/log.all.controller.js